import { render } from "./RecetaDet.vue?vue&type=template&id=21dd09ea&scoped=true"
import script from "./RecetaDet.vue?vue&type=script&lang=js"
export * from "./RecetaDet.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=21dd09ea&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dd09ea"]])

export default __exports__